import { render, staticRenderFns } from "./FormDependentInfo.vue?vue&type=template&id=f797f644"
import script from "./FormDependentInfo.vue?vue&type=script&lang=js"
export * from "./FormDependentInfo.vue?vue&type=script&lang=js"
import style0 from "./FormDependentInfo.vue?vue&type=style&index=0&id=f797f644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports